export default __webpack_public_path__ + "static/media/IMG_3530.e850f808.jpg";